export enum RangeGapOption {
  Zero = '0',
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5'
};

export const DEFAULT_RANGE_GAP_OPTION = RangeGapOption.Zero;

export const RANGE_GAP_OPTIONS_ARRAY = Object.values(RangeGapOption);

export function isRangeGapOption(unknownValue: unknown): unknownValue is RangeGapOption {
  return (RANGE_GAP_OPTIONS_ARRAY as unknown[]).includes(unknownValue);
}
